import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { commonErrorResponses, emptyEnvelopeSchema, requiredPayloadEnvelope } from '../envelope.js';
const c = initContract();
/** 채널 연결이 가리키는 수집 플랫폼이다. `LoginMethod.provider`의 google은 youtube로 읽는다. */
export const streamChannelPlatformSchema = z.enum(['soop', 'twitch', 'youtube', 'chzzk']);
/**
 * 사용자가 방송 채널로 연결한 플랫폼 계정 한 줄이다.
 * OAuth 링크와 SOOP 선언 행을 같은 모양으로 내보낸다. 로그인 수단 목록(`loginMethodSchema`)과 분리한다.
 */
export const streamChannelSchema = z.object({
    /** 해제 요청에 쓰는 id. `LoginMethod.id`와 같다. */
    id: z.string(),
    platform: streamChannelPlatformSchema,
    /** 그 플랫폼의 채널 식별자. SOOP은 bjId다. */
    channelNativeId: z.string(),
    /** 소유가 확인된 시각. SOOP 선언 행은 검증 수단이 없어 null이다. */
    verifiedAt: z.string().nullable(),
    createdAt: z.string(),
});
/** SOOP bjId 입력 계약이다. 서버가 trim·소문자 정규화를 다시 하므로 여기서는 길이만 막는다. */
export const soopChannelClaimBodySchema = z.object({
    bjId: z.string().min(1).max(64),
});
export const userStreamChannelsContract = c.router({
    listStreamChannels: {
        method: 'GET',
        path: '/user/stream-channels',
        responses: {
            200: requiredPayloadEnvelope(z.object({ channels: z.array(streamChannelSchema) })),
            ...commonErrorResponses,
        },
    },
    /** SOOP은 OAuth가 없어 사용자가 bjId를 선언한다. 같은 bjId는 한 계정만 선점한다(409). */
    claimSoopChannel: {
        method: 'POST',
        path: '/user/stream-channels/soop',
        body: soopChannelClaimBodySchema,
        responses: {
            201: requiredPayloadEnvelope(z.object({ channel: streamChannelSchema })),
            ...commonErrorResponses,
        },
    },
    /** 채널 전용 행만 해제한다. OAuth 링크는 로그인 수단 해제 경로를 쓴다. */
    releaseStreamChannel: {
        method: 'POST',
        path: '/user/stream-channels/:id/release',
        pathParams: z.object({ id: z.string() }),
        body: z.null().optional(),
        responses: {
            200: emptyEnvelopeSchema,
            ...commonErrorResponses,
        },
    },
});
//# sourceMappingURL=stream-channels.contract.js.map